module.exports = __webpack_public_path__ + "static/media/wind-logo-svg-vector.9711464a.svg";